import styled from 'styled-components'
import { colors, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import { Button } from '@chegg-ui/button'
import { ChevronIcon } from '@chegg-ui/horizon-icons'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'

export const BetaReleaseContainer = styled.div`
  display: flex;
  padding: ${spacing.px4} ${spacing.px8} 2px ${spacing.px8};
  justify-content: center;
  border-radius: ${spacing.px4};
  background: ${colors.violet100};
  align-items: center;
  margin: ${spacing.px8} 0;
`

export const BetaReleaseText = styled(Typography).attrs({
  variant: 'body2',
  variantType: 'bold',
})`
  color: ${colors.violet600};
  display: flex;
  align-items: flex-start;
  > span {
    margin-left: ${spacing.px4};
  }
`

export const EntryBanner = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${spacing.px8};
  background: ${colors.orange050};
  padding: ${spacing.px4} ${spacing.px24} ${spacing.px4} ${spacing.px32};

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
  }
`

export const BannerHeading = styled(Typography).attrs({
  variant: 'h5',
  variantType: 'bold',
})`
  margin: ${spacing.px8} 0 ${spacing.px8} 0;
  > span {
    color: ${colors.cheggOrange};
  }
`
export const TextSection = styled.div`
  flex-grow: 1;
  padding-right: ${spacing.px24};
`

export const ImageContainer = styled.div`
  margin: ${spacing.px8} ${spacing.px24} ${spacing.px8} 0;
  display: flex;
  align-items: center;
`
export const GetStartedButton = styled(Button)`
  margin: ${spacing.px16} 0;
  font-weight: normal;
  font-size: ${spacing.px16};
  height: ${spacing.px32};
  &&& {
    background: ${colors.grey900};
  }
`

export const ArrowIcon = styled(ChevronIcon).attrs({
  pointing: 'right',
  size: 'xsmall',
})`
  margin-left: ${spacing.px8};
`

export const BannerHeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.px16};
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
  }
`
